const CategoriesFactory = (NewBackendService, NewTokenService, $q, $http, StorageService, endPoints) => {
  'ngInject';

  //UTILS
  const getCookie = (cname) => {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  };

  /*const getConfigWithAccessToken = () => {
    const config = { headers: {} };
    config.headers = {};
    config.headers['Authorization'] = 'Bearer ' + StorageService.getLocalStorage('access_token');
    return config;
  };


  const hget = (path) => {
    const config = getConfigWithAccessToken();
    return $http.get(path, config);
  };


  const hput = (path, data, config = {}) => {
    _.merge(config, getConfigWithAccessToken());
    return $http.put(path, data, config);
  };*/

  const service = {

    setMerchantCategories: (data, shopId) => $q(
      (resolve, reject) => {
        return NewBackendService.invokeWebApiPut(`${endPoints.userUrl}/shops/${shopId}/categories`, data, { headers: { 'Content-Type': 'text/uri-list' }}).then(resolve, reject);
      }
    ),

    getMerchantShop: (businessId, shopId) => $q(
      (resolve, reject) => {
        return NewBackendService.invokeWebApiGet(`${endPoints.userUrl}/businesses/${businessId}/shops/${shopId}`).then(
          response => {
            const data = response.data || [];
            resolve(data);
          }, error => {
            reject(error);
          }
        );
        ;
      }
    ),

    getMerchantCategories: (shopId) => $q(
      (resolve, reject) => {
        return NewBackendService.invokeWebApiGet(`${endPoints.userUrl}/shops/${shopId}/categories`).then(
          response => {
            const data = response.data._embedded || [];
            resolve(data);
          }, error => {
            reject(error);
          }
        );
        ;
      }
    ),

    getAllCategories: () => $q(
      (resolve, reject) => {
        return NewBackendService.invokeWebApiGet(`${endPoints.userUrl}/shops/categories`).then(response => {
          const data = response.data._embedded || [];
          resolve(data);
        }, reject);
      }
    )
  };

  return service;
};

export default CategoriesFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/categories.factory.js
 **/